module.exports = __webpack_public_path__ + "static/img/1.8ae9de5.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/1.png
// module id = 947
// module chunks = 30